import React, { useEffect } from 'react';
import SelectUnbindDevices from '../SelectUnbindDevices';
import { useTranslation } from 'react-i18next';
import useSelectDevices from '@root/hooks/defaultPackage/useSelectDevices';
import useHouseList from '@root/hooks/useHouseList';
import HouseSelector from '@root/components/HouseSelector';

const PromotionsSelectDevice = () => {
  const { houses, getHouseList, currentHouseId, setCurrentHouseId } =
    useHouseList();

  const isHouses = houses.length > 0;

  // 活动页登录完直接跳选择页面
  // 所以要获取家数据
  useEffect(() => {
    if (isHouses) {
      return;
    }
    getHouseList();
  }, [getHouseList, isHouses]);

  const {
    isUnlimited,
    selectedPrice,
    maxDevNum,
    paying,
    selected,
    payMethodState,
    onSelected,
    onClickPay,
  } = useSelectDevices({ isPromotions: true });
  const { t } = useTranslation();

  return (
    <SelectUnbindDevices
      selected={selected}
      maxDevNum={maxDevNum}
      isUnlimited={isUnlimited}
      paying={paying}
      onChange={onSelected}
      onClickPay={onClickPay}
      btnText={t('purchase_now')}
      payMethodState={payMethodState}
      isHomeIcon={false}
      renderHeader={() => (
        <div className="select-device-home">
          <HouseSelector
            currentHouseId={currentHouseId}
            houseList={houses}
            onSelect={setCurrentHouseId}
          />
        </div>
      )}
    >
      {isUnlimited && (
        <div className="footer-tips">
          <span className="total">
            {t('total')}: ${selectedPrice.price}
            {` / ${t('month')}`}
          </span>
          <span className="float-right">{`${selected.length} ${
            selected.length > 1 ? t('devices') : t('device')
          }`}</span>
        </div>
      )}
    </SelectUnbindDevices>
  );
};

export default PromotionsSelectDevice;
